module.exports = __webpack_public_path__ + "img/explain.ebc28ac1.png";